module.exports = __webpack_public_path__ + "img/Vector24.15cfc873.svg";